import { render } from "./VaIconMenuCollapsed.vue?vue&type=template&id=25cc4d42"
import script from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"
export * from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"

import "./VaIconMenuCollapsed.vue?vue&type=style&index=0&id=25cc4d42&lang=scss"
script.render = render

export default script